import styled from "styled-components";
import { ImageLoader, ButtonText } from "@loanbossinc/component-library";

export const PageContainer = styled.div`
  max-width: 1120px;
  margin: auto;
  display: flex;
  flex-direction: column;
`;
export const ImageBanner = styled.div`
  width: 100%;
  height: 320px;
`;
export const StyledImgLoader = styled(ImageLoader)`&& {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
`;
export const DebtValuationParamsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin-top: -10em;
`;
export const DebtValuationParamsWrapper = styled.div`
  display: block;
  font-family: Work Sans;
  width: 360px;
  box-shadow: 0px 10px 20px rgb(173 174 174 / 25%);
  border-radius: 8px;
  width: 700px;
  text-align: center;
  background: #FFFFFF;
  position: sticky !important;
  z-index: 1;
`;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 34px;
  `;
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 16px;
  margin-right: 16px;
`;
export const Title = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #005AA9;
`;
export const SubTitle = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #5F6368;
  margin-top: 20px;
`;
export const SectionTitle = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;
export const ControllsWrapper = styled.div`
  display: flex;
  flex-direction: row;    
  justify-content: space-between;
  align-items: center;
  margin-top: 1em;
  margin-bottom: 1em;
`;
export const Divider = styled.div`
  border: 1px solid #DADCE0;
  width: 100%;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-right: 34px;
`;
export const FooterContainer = styled.div`
  padding: 10px 6px;
  background: #f5f5f5;
`;

export const StyledButtonText = styled(ButtonText)`&& {
    margin-left: 16px;
    .label {
      margin-left: 14px;
    }
  }
`;
